<template>
	<link-dialog dialogClass="document-login-dialog" v-model="show" width="400px" confirmButton title="请先登录" noClose confirmButtonText="登录" disabledHideOnConfirm @confirm="handleConfirm" :loading="loading">
		<link-form ref="form">
			<link-form-column>
				<link-form-item label="用户名">
					<link-input v-model="user.username" long size="large" required @enter="handleConfirm" placeholder="请输入用户名"/>
				</link-form-item>
				<link-form-item label="密码">
					<link-input v-model="user.password" long size="large" required inputType="password" @enter="handleConfirm" placeholder="请输入密码"/>
				</link-form-item>
			</link-form-column>
		</link-form>
	</link-dialog>
</template>

<script>

    export default {
        name: "document-login-dialog",
        data() {
            return {
                show: false,
                loading: false,
                user: {
                    username: null,
                    password: null,
                },
            }
        },
        methods: {
            login(callback) {
                this.show = true
                this.user = {
                    username: null,
                    password: null,
                }
                this.callback = callback
            },
            handleConfirm() {
                if (!!this.$refs.form.validate()) {
                    this.loading = true
                    this.$lv.$documentLogin.login('action/base/user/login', this.user.username, this.user.password, (data) => {
                        !!this.callback && this.callback(data)
                        this.show = false
                        this.loading = false
                    }, (e) => {
                        console.log(e)
                        this.$dialog.show('登录失败！' + e)
                        this.loading = false
                    });
                }
            },
        }
    }
</script>

<style lang="scss">
	.document-login-dialog {
		.link-form {
			width: 100%;

			.link-form-column {
				width: 100%;
			}
		}
	}
</style>
